import React from 'react';
export function ClosingSection() {
  return <section className="w-full bg-[#0a0a0a] py-10 md:py-16 px-4 border-t border-gray-800" data-id="element-45">
      <div className="max-w-2xl mx-auto text-center" data-id="element-46">
        <p className="text-xs text-[#c41e3a] font-black tracking-widest uppercase mb-4" data-id="element-47">
          La decisión es tuya
        </p>
        <h2 className="text-2xl md:text-4xl font-black text-white mb-4 leading-tight" data-id="element-48">
          La diferencia entre intentarlo…
        </h2>
        <p className="text-2xl md:text-4xl font-black text-[#c41e3a] mb-8 leading-tight" data-id="element-49">
          y hacerlo profesionalmente.
        </p>

        <div className="w-16 h-0.5 bg-[#c41e3a] mx-auto mb-8" data-id="element-50"></div>

        <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-3 max-w-lg mx-auto" data-id="element-51">
          Podés seguir aprendiendo de forma desordenada.
        </p>
        <p className="text-gray-200 text-sm md:text-base font-semibold leading-relaxed mb-8 max-w-lg mx-auto" data-id="element-52">
          O podés formarte con un método estructurado que te enseñe técnica,
          criterio y profesionalización.
        </p>

        <p className="text-white font-black text-base md:text-lg mb-10" data-id="element-53">
          Método Barber Pro no es improvisación.{' '}
          <span className="text-[#c41e3a]" data-id="element-54">Es estructura.</span>
        </p>

        <div className="flex flex-col items-center gap-3" data-id="element-55">
          <a href="#pricing" className="cta-primary text-white font-black text-base md:text-xl px-10 md:px-14 py-4 md:py-5 rounded-lg inline-block text-center" aria-label="Empezar mi formación ahora" data-id="element-56">
            👉 EMPEZAR MI FORMACIÓN AHORA
          </a>
          <p className="text-gray-600 text-xs font-semibold" data-id="element-57">
            Acceso inmediato · Producto digital · Sin vencimiento
          </p>
        </div>
      </div>
    </section>;
}